import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController } from "@ionic/angular";
import { map } from 'rxjs/operators';
let apiUrl = apiBaseUrl + "seeds/";
@Injectable({
  providedIn: 'root'
})
export class SeedService {
  public config: any;
  public insuranceCompany: any;
  public appType: any;
  public headers: any;
  public getSeedBuff = [];
  public buffIndex = 0;
  constructor(
    public http: HttpClient,
    private platform: Platform,
  ) { 
    this.headers = contentHeaders;
  }
  checkBuffer(sleep) {
    setTimeout(() => {
      if (this.buffIndex < this.getSeedBuff.length) {
        this.getSeed(
          this.getSeedBuff[this.buffIndex].class,
          this.getSeedBuff[this.buffIndex].app,
          this.getSeedBuff[this.buffIndex].company,
          this.getSeedBuff[this.buffIndex].branch,
          this.getSeedBuff[this.buffIndex].title,
          this.getSeedBuff[this.buffIndex].parents
        ).then((res) => {
          this.buffIndex++;
          this.checkBuffer(sleep);
        }).catch((e) => {
          console.log("our: not getting seeds", e, this.getSeedBuff[this.buffIndex]);
          this.buffIndex++;
          this.checkBuffer(sleep);
        });
      }
    }, sleep);
  }

  getSeedByApi(className: String, app?: String, companyId?: String, branchId?: String, title?: String, parentIds?: Array<String>) {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl +"?class="+className+"&app="+app+"&companyId="+companyId+"&branchId="+branchId+"&title="+title+"&parentId="+parentIds.join(","),{headers: this.headers})
        .subscribe((res) => {
          let t = res['data'][0];
          resolve(t);
        }, (err) => { reject(err); });
    });
  }

  getSeed(className: String, app?: String, companyId?: String, branchId?: String, title?: String, parentIds?: Array<String>) {
    return new Promise((resolve, reject) => {
      resolve(this.getSeedByApi(className, app, companyId, branchId, title, parentIds));
    });
  }
  getSeedbyId(id) {
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + id, { headers: this.headers }).subscribe((res) => {
        resolve(res['data']);
      },(err) => {
        reject(err);
      });
    });
  }
  getNewSeedbyUrl(url, data) {
    return new Promise((resolve, reject) => {
      this.http.get(apiBaseUrl + url + data.join(","), { headers: this.headers }).subscribe((res) => {
        let t = res['data'] && res['data'].length > 0 ? res['data'] : [];
        if(t && t.length > 1){
          t.sort(function (a, b) {
            a = a.title.toLowerCase();
            b = b.title.toLowerCase();
            return a < b ? -1 : a > b ? 1 : 0;
          });
        }
        resolve(t);
      }, (err) => {
        reject(err);
      });
    });
  }
  compareStrings(a, b) {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();
    return a < b ? -1 : a > b ? 1 : 0;
  }
  getSeedbyUrl(url, data) {
    return new Promise((resolve, reject) => {
      resolve(this.getNewSeedbyUrl(url, data));
    });
  }
}
